var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6665b95b\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./comingsoon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/common/comingsoon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] comingsoon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6665b95b", Component.options)
  } else {
    hotAPI.reload("data-v-6665b95b", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/common/comingsoon.vue
// module id = 690
// module chunks = 0